export default __webpack_public_path__ + "static/media/logo-child5.c521937a.svg";